import React from 'react';
import { EmptyState } from '@spark';

/**
 * No-model empty state (Figma 1806:104336 "size-row-placeholder"): a centered
 * white card with the Spark Empty State — open-box illustration, title,
 * subtitle, and a ghost "Add Model" CTA (icon hidden per the design).
 * Shown whenever the Playground has no model slots, even if example rows
 * are loaded.
 */
const PlaygroundEmptyState = ({ onAddModel }) => (
    <div className="pg-empty fs-unmask">
        <div className="pg-empty__card">
            <EmptyState
                title="Add a model to see results here"
                subtitle="Compare a commercial model with your own, side by side."
                showSubtitle
                showMainButton
                showCtaIcon={false}
                ctaLabel="Add Model"
                onCtaClick={onAddModel}
            />
        </div>
    </div>
);

export default PlaygroundEmptyState;
